module.exports = __webpack_public_path__ + "static/media/picto_fleche_differenciant.38f81f8f.svg";